import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { People } from '@mui/icons-material';
import RecruitmentManagement from '../../components/SuperAdmin/RecruitmentManagement';

const RecruitmentManagementPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Box sx={{
        mb: 4,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        borderRadius: 2,
        p: 3,
        color: 'white'
      }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
          <People sx={{ mr: 2, verticalAlign: 'middle', fontSize: 'inherit' }} />
          Recruitment Management
        </Typography>
        <Typography variant="h6" sx={{ opacity: 0.9, fontWeight: 300 }}>
          Review teaching job applications, approve candidates, and manage the hiring process
        </Typography>
      </Box>

      {/* Recruitment Management Component */}
      <RecruitmentManagement />
    </Container>
  );
};

export default RecruitmentManagementPage;
